import queryLoopLoaded from "@plaudit/query-loop.api";

import QueryLoopFormFieldBase from "./QueryLoopFormFieldBase";

export class TextQueryLoopFormField extends QueryLoopFormFieldBase {
	protected readonly input: HTMLInputElement|HTMLTextAreaElement;

	public constructor(field: HTMLFieldSetElement, type: string) {
		super(field, type);
		const input = field.querySelector('.plauditQueryLoopField__input');
		if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
			this.input = input;
		} else {
			throw new Error("Attempted to attach an invalid field");
		}
		this.postConstruct();
	}

	public getValue(): string {
		return this.input.value;
	}
	public setValue(value: string|string[]) {
		if (Array.isArray(value)) {
			value = value.join(' ');
		}
		if (this.input.value !== value) {
			this.input.value = value;
			this.updateValueIsDefaultFlag();
			return true;
		}
		return false;
	}

	public loadIntoQuery(params: URLSearchParams) {
		this.replaceMyPotentialPHPArrayParametersWithFirstValue(params);
		return this.loadIndividualValueIntoQuery(this.getValue(), params);
	}
	public loadFromQuery(params: URLSearchParams) {
		return this.setValue(params.get(this.input.name) ?? '');
	}

	public getLabeledValues(selectedOnly?: boolean) {
		return selectedOnly && !this.getValue() ? [] : [{field: this.name, value: this.getValue(), label: this.getValue()}];
	}

	protected getDefaultValue(): string {
		return this.input.getAttribute('data-default') ?? '';
	}

	public isSingleValued() {
		return true;
	}
}

queryLoopLoaded.then(() => {
	plaudit.queryLoop.fieldTypes.set('text', field => new TextQueryLoopFormField(field, 'text'));
	plaudit.queryLoop.fieldTypes.set('textarea', field => new TextQueryLoopFormField(field, 'textarea'));
});
